import { AppHeader } from 'src/business/components'
import Leaderboard from 'src/business/components/leaderBoard/LeaderBoard'
import UserStats from 'src/business/components/leaderBoard/UserStats'
import { MentalStateIndexComponent } from 'src/business/components/moodIndexWidget'
import MyMembershipWidget from 'src/business/components/myMembershipWidget'
import Goals from '../UserProfile/goals'

const Dashboard = (props) => {
  return (
    <>
      <AppHeader heading="Dashboard" />
      <main
        className="px-3 py-4 px-sm-4 py-sm-5"
        style={{
          maxWidth: '1600px',
          margin: '0 auto',
          width: '100%',
          boxSizing: 'border-box',
          overflowX: 'hidden',
        }}
      >
        <MentalStateIndexComponent />
        <MyMembershipWidget />
        <Goals />
        <UserStats />
        <Leaderboard />
      </main>
    </>
  )
}

export default Dashboard
